import { ScheduleDetailsComponent } from './presence-details.component';
export default ScheduleDetailsComponent;
